import React from 'react'
import { Mail, ArrowRight, Users } from 'lucide-react'
import { useLocalization } from '../../hooks/useLocalization'

/**
 * Partnership CTA Section Component
 * 
 * Call-to-action section encouraging companies to become partners
 */
const PartnershipCTASection: React.FC = () => {
  const { t } = useLocalization()

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white dark:bg-gray-900">
      <div className="max-w-4xl mx-auto">
        <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-8 sm:p-10 border-2 border-blue-200 dark:border-blue-800 border-dashed">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center mx-auto mb-4">
              <Users className="w-8 h-8 text-blue-600 dark:text-blue-400" />
            </div>
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 dark:text-white mb-4">
              {t('home.partnership.cta.title')}
            </h2>
            <p className="text-lg text-gray-700 dark:text-gray-300 mb-6">
              {t('home.partnership.cta.subtitle')}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
            <a
              href={`mailto:${t('home.partnership.cta.contactEmail')}?subject=Partnership Inquiry`}
              className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
            >
              <Mail className="w-5 h-5 mr-2" />
              {t('home.partnership.cta.explorePartnership')}
            </a>
            <a
              href={`mailto:${t('home.partnership.cta.contactEmail')}?subject=Demo Request`}
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-blue-600 text-blue-600 dark:text-blue-400 font-medium rounded-lg hover:bg-blue-50 dark:hover:bg-blue-900/30 transition-colors"
            >
              {t('home.partnership.cta.requestDemo')}
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
          </div>

          <div className="text-center pt-6 border-t border-blue-200 dark:border-blue-800">
            <p className="text-sm text-gray-600 dark:text-gray-300">
              {t('home.partnership.cta.contactLabel')}{' '}
              <a
                href={`mailto:${t('home.partnership.cta.contactEmail')}`}
                className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 font-medium"
              >
                {t('home.partnership.cta.contactEmail')}
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PartnershipCTASection
